const departmentList = {
  gm: "Quản Lý",
  sec: "An Ninh",
  hk: "Buồng Phòng",
  me: "Bảo Trì",
  kit: "Bếp",
  sale: "Kinh Doanh",
  acc: "Kế Toán",
  mkt: "Marketing",
  hr: "Nhân Sự",
  stw: "Steward",
  fo: "Tiền Sảnh",
  fb: "Ẩm Thực",
  dev: "Developer",
  any: "*",
};

export default departmentList;
